export const TabConfig={
    "MDM_Tabs": {
        "Suspected_Matches": true,//This will always remain true
        "DCR_Management": false,
        "All_Records": true,//This will always remain true
        "Activity_Log": true,//This will always remain true
        "Advanced_Search": false,
    },
    "Entity_Type":{
        "HCP": true,
        "HCO": true,
        "PAYER": false,//If Payer is false, then set all the Payer_Tabs to false
    },
    "Payer_Tabs":{
        "PAYER": false,
        "PLAN": false,
        "PBM": false,
        "MCO": false
    }
    }
